<template>
  <div>
      <video autoplay muted loop class="hover_video" src="@/assets/video/motiontech.mp4"></video>
      <p class="description pd-top-40">
        Motion Technology (MotionTech) menghadirkan lingkungan kerja yang dinamis, efisien, nyaman, dengan dilengkapi fasilitas teknologi terkini. MotionTech menjadi wadah bagi unit MNC Financial Services sebagai ekosistem jasa keuangan digital paling terintegrasi di Indonesia. Kehadiran MotionTech merupakan bagian penting dari rencana strategi digital MNC Group untuk masa depan.
      </p>
      <!-- <p class="link description mg-top-20" @click="movePage()">Selengkapnya</p> -->
  </div>
</template>

<script>
export default {
  name: 'Motion',
  data () {
    return {

    }
  },
  methods: {
    movePage() {
      this.$router.push('/motion-tech')
    }
  }
}
</script>
